// extracted by mini-css-extract-plugin
export default {"personalAccount":"PersonalAccount_personalAccount__N2ktD","contentWrapper":"PersonalAccount_contentWrapper__EBoGT"};